/**
 * useAccountFeature(accountId, key) — whether an optional module is switched
 * on for an account (GET /accounts/{id}/features, one cached request per
 * account). `false` until known, on a failed read and with no account, so an
 * optional module never shows by mistake. See useAccountFeatureWith (shared).
 *
 * After switching a feature, call useInvalidateAccountFeatures()(accountId)
 * so every screen asking about it updates.
 */
import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { accountFeaturesQueryKey, useAccountFeatureWith, type AccountFeatureState } from '@turn-connect/shared';
import { webApiClient } from '../services/apiClient';

export function useAccountFeature(
  accountId: string | null | undefined,
  key: string,
  options: { enabled?: boolean } = {}
): AccountFeatureState {
  return useAccountFeatureWith(webApiClient, accountId, key, options);
}

export function useInvalidateAccountFeatures(): (accountId: string) => Promise<void> {
  const qc = useQueryClient();
  return useCallback((accountId: string) => qc.invalidateQueries({ queryKey: accountFeaturesQueryKey(accountId) }), [qc]);
}
